"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllBookingInsurancesExtraReducers = void 0;
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const services_1 = tslib_1.__importDefault(require("../../../../services"));
const Insurance_1 = tslib_1.__importDefault(require("./__models__/Insurance"));
const refreshBooking_1 = tslib_1.__importDefault(require("../../bookings/refreshBooking"));
const getAllBookingInsurances = toolkitRaw.createAsyncThunk('bookings/list_insurances', async ({ bookingInternalId, options }, { rejectWithValue, dispatch }) => {
    try {
        const response = await services_1.default.get(`/api/saas/me/bookings/${bookingInternalId}/insurances`);
        const InsuranceImplementation = new Insurance_1.default(response);
        if (options === null || options === void 0 ? void 0 : options.refreshBooking) {
            dispatch((0, refreshBooking_1.default)({ bookingInternalId, options: { onlyMeta: true } }));
        }
        return {
            data: InsuranceImplementation.data,
            meta: InsuranceImplementation.meta,
        };
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const getAllBookingInsurancesExtraReducers = (builder) => {
    builder.addCase(getAllBookingInsurances.pending, (state) => {
        state.booking.slices.insurances.loading = true;
    });
    builder.addCase(getAllBookingInsurances.fulfilled, (state, action) => {
        state.booking.slices.insurances.loading = false;
        state.booking.slices.insurances.data = action.payload.data;
        state.booking.slices.insurances.meta = action.payload.meta;
    });
    builder.addCase(getAllBookingInsurances.rejected, (state) => {
        state.booking.slices.insurances.loading = false;
    });
};
exports.getAllBookingInsurancesExtraReducers = getAllBookingInsurancesExtraReducers;
exports.default = getAllBookingInsurances;
//# sourceMappingURL=index.js.map